<template>
    <v-app>
        <v-container fluid>
            <role-setup  v-if="dialog" :dialog="dialog" :data="data" @update:dialog="dialog = $event" />
            <template v-if="$insertAccess($route.fullPath)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel">
                                <v-expansion-panel>
                                    <v-expansion-panel-title class="panel-header">Role Permission</v-expansion-panel-title>
                                    <v-expansion-panel-text class="expansion-padding">
                                            <v-row class="no-gutters justify-center">
                                                <v-col lg="3" md="3" cols="12">    
                                                        <v-autocomplete
                                                            label="Select Company"
                                                            density="compact"
                                                            single-line
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            v-model="company_id.value.value"
                                                            :error-messages="company_id.errorMessage.value"
                                                            clearable
                                                            :items="getCompanyList.filter(item=> item.status == 1)"
                                                            :item-title="item => `${item.name} - ${item.code}`"                                                  
                                                            item-value="id" 
                                                            autocomplete="off"
                                                        ></v-autocomplete>
                                                </v-col>

                                                <v-col lg="3" md="3" cols="12">    
                                                        <v-autocomplete
                                                            label="Select Branch"
                                                            density="compact"
                                                            single-line
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            v-model="branch_id.value.value"
                                                            :error-messages="branch_id.errorMessage.value"
                                                            clearable
                                                            :items="getBranchList.filter(item => item.company_id == company_id.value.value)"
                                                            :item-title="item => `${item.code} - ${item.name}`"                                                  
                                                            item-value="id"
                                                            autocomplete="off"
                                                            @update:modelValue="getModulesByBranch" 
                                                        ></v-autocomplete>                                                                                             
                                                </v-col>

                                                <v-col lg="3" md="3" cols="12">
                                                    <v-autocomplete
                                                        label="Select Role"
                                                        density="compact"
                                                        single-line
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        v-model="role_id.value.value"
                                                        clearable
                                                        hide-details
                                                        :items="getSchema.filter(item => item.branch_id == this.branch_id.value.value)"
                                                        :item-title="item => `${item.code} - ${item.name}`"                                                  
                                                        item-value="id"
                                                        append-icon="mdi mdi-plus"
                                                        @update:modelValue="getRolePermission"
                                                        @click:append="addRoleUrl"
                                                        autocomplete="off" 
                                                    >                                              
                                                    </v-autocomplete> 
                                                </v-col>
                                            </v-row>


                                    <!-- Role Permission -->
                                        <v-row v-if="section_show">
                                            <v-col cols="12"><v-alert text="Role Permission" density="compact" color="success"></v-alert> </v-col>
                                            <v-col lg="6" md="6" cols="12" xs="12">
                                                <v-skeleton-loader :loading="module_loading" type="heading"> 
                                                <v-row>                                    
                                                    <v-col cols="12">      
                                                        <div v-for="(item, index) in getModule" :key="index">                                                         
                                                            <v-expansion-panels v-if="index < moduleLength" class="my-4">
                                                                <v-expansion-panel>
                                                                        <v-expansion-panel-title class="panel-header-role">
                                                                            <div class="d-flex justify-space-between align-center w-100">
                                                                                <span>{{ item.companies_modules?.module.name }}</span>
                                                                                <div class="d-flex align-center">
                                                                                    <v-checkbox
                                                                                        :id="'module_all_'+item.companies_modules?.module.id+'_left'"
                                                                                        density="compact"
                                                                                        hide-details
                                                                                        color="primary"
                                                                                        :model-value="isModuleAllSelected(item)"
                                                                                        @update:model-value="toggleModuleAllPermissions(item, index, $event)"
                                                                                        @click.stop
                                                                                        class="mr-2"
                                                                                    >
                                                                                        <template v-slot:label>
                                                                                            <span class="text-caption">{{ isModuleAllSelected(item) ? 'Unselect All Module' : 'Select All Module' }}</span>
                                                                                        </template>
                                                                                    </v-checkbox>
                                                                                </div>
                                                                            </div>
                                                                        </v-expansion-panel-title>
                                                                        <v-expansion-panel-text>
                                                
                                                                                <v-table class="permission-table" density="compact" v-for="(sub_module, index2) in item.companies_modules.module.sub_module" :key="index2">
                                                                                    <thead>
                                                                                    <tr>
                                                                                        <th class="text-left" style="width:50%">
                                                                                            <div class="d-flex flex-column">
                                                                                                <strong>{{ sub_module.name }}</strong>
                                                                                                <div class="d-flex align-center mt-1">
                                                                                                    <v-checkbox
                                                                                                        :id="'sub_module_all_'+sub_module.id+'_left'"
                                                                                                        density="compact"
                                                                                                        hide-details
                                                                                                        color="primary"
                                                                                                        :model-value="isSubModuleMenuAllSelected(sub_module)"
                                                                                                        @update:model-value="toggleSubModuleMenuAllPermissions(sub_module, $event)"
                                                                                                        class="pa-0"
                                                                                                    >
                                                                                                        <template v-slot:label>
                                                                                                            <span class="text-caption">{{ isSubModuleMenuAllSelected(sub_module) ? 'Unselect All' : 'Select All' }}</span>
                                                                                                        </template>
                                                                                                    </v-checkbox>
                                                                                                </div>
                                                                                            </div>
                                                                                        </th>
                                                                                        <th class="text-left" style="width:12.5%">
                                                                                            <div class="d-flex flex-column align-center">
                                                                                                <span>View</span>
                                                                                                <v-checkbox
                                                                                                    :id="'sub_view_all_'+item.companies_modules.module.id+'_'+sub_module.id"
                                                                                                    density="compact"
                                                                                                    hide-details
                                                                                                    color="indigo"
                                                                                                    :model-value="isSubModuleAllSelected(sub_module, 'view')"
                                                                                                    @update:model-value="selectAllSubModulePermissions(sub_module, 'view', $event)"
                                                                                                ></v-checkbox>
                                                                                            </div>
                                                                                        </th>
                                                                                        <th class="text-left" style="width:12.5%">
                                                                                            <div class="d-flex flex-column align-center">
                                                                                                <span>Insert</span>
                                                                                                <v-checkbox
                                                                                                    :id="'sub_insert_all_'+item.companies_modules.module.id+'_'+sub_module.id"
                                                                                                    density="compact"
                                                                                                    hide-details
                                                                                                    color="primary"
                                                                                                    :model-value="isSubModuleAllSelected(sub_module, 'insert')"
                                                                                                    @update:model-value="selectAllSubModulePermissions(sub_module, 'insert', $event)"
                                                                                                ></v-checkbox>
                                                                                            </div>
                                                                                        </th>
                                                                                        <th class="text-left" style="width:12.5%">
                                                                                            <div class="d-flex flex-column align-center">
                                                                                                <span>Update</span>
                                                                                                <v-checkbox
                                                                                                    :id="'sub_update_all_'+item.companies_modules.module.id+'_'+sub_module.id"
                                                                                                    density="compact"
                                                                                                    hide-details
                                                                                                    color="info"
                                                                                                    :model-value="isSubModuleAllSelected(sub_module, 'update')"
                                                                                                    @update:model-value="selectAllSubModulePermissions(sub_module, 'update', $event)"
                                                                                                ></v-checkbox>
                                                                                            </div>
                                                                                        </th>
                                                                                        <th class="text-left" style="width:12.5%">
                                                                                            <div class="d-flex flex-column align-center">
                                                                                                <span>Delete</span>
                                                                                                <v-checkbox
                                                                                                    :id="'sub_delete_all_'+item.companies_modules.module.id+'_'+sub_module.id"
                                                                                                    density="compact"
                                                                                                    hide-details
                                                                                                    color="red"
                                                                                                    :model-value="isSubModuleAllSelected(sub_module, 'delete')"
                                                                                                    @update:model-value="selectAllSubModulePermissions(sub_module, 'delete', $event)"
                                                                                                ></v-checkbox>
                                                                                            </div>
                                                                                        </th>
                                                                                    </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr v-for="(menu, index3) in sub_module.menu" :key="menu.id" v-if="sub_module.menu.length > 0" :class="{ 'striped-row': index3 % 2 == 1 }">
                                                                                            <td class="text-left pl-25" > <v-icon icon="mdi mdi-square-small" size="x-large"></v-icon>{{ menu.name }}</td>
                                                                                            <td class="py-0 text-center">
                                                                                                <span class="d-flex justify-center">
                                                                                                    <v-checkbox   
                                                                                                        :id="'menu_view_'+menu.id"                         
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="indigo" 
                                                                                                        v-model="menuViewPermissions[menu.id]"                                  
                                                                                                    ></v-checkbox>
                                                                                                </span>

                                                                                            </td>
                                                                                            <td class="py-0 text-center">
                                                                                                <span v-if="menu.insert > 0" class="d-flex justify-center">
                                                                                                    <v-checkbox   
                                                                                                        :id="'menu_insert_'+menu.id"                         
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="primary" 
                                                                                                        v-model="menuInsertPermissions[menu.id]"                                  
                                                                                                    ></v-checkbox>
                                                                                                </span>

                                                                                            </td>
                                                                                            <td class="py-0 text-center">
                                                                                                <span v-if="menu.update > 0" class="d-flex justify-center">
                                                                                                    <v-checkbox     
                                                                                                        :id="'menu_update_'+menu.id"                       
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="info"    
                                                                                                        v-model="menuUpdatePermissions[menu.id]"                                                         
                                                                                                    ></v-checkbox>
                                                                                                </span>
                                                                                            </td>
                                                                                            <td class="py-0 text-center">
                                                                                                <span v-if="menu.delete > 0" class="d-flex justify-center">
                                                                                                    <v-checkbox      
                                                                                                        :id="'menu_delete_'+menu.id"                      
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="red" 
                                                                                                        v-model="menuDeletePermissions[menu.id]"                                                                         
                                                                                                    ></v-checkbox>
                                                                                                </span>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr v-else>
                                                                                            <td colspan="4" class="text-center"><small class="red" >Menu Not Found</small></td>
                                                                                        </tr>
                                                                                    
                                                                                    </tbody>
                                                                                </v-table>
                                                                                                
                                                                        </v-expansion-panel-text>
                                                                    </v-expansion-panel>
                                                            </v-expansion-panels>       
                                                        </div>                                                    
                                                    </v-col>
                                                </v-row>
                                                </v-skeleton-loader>
                                            </v-col>

                                            <v-col lg="6" md="6" cols="12" xs="12">
                                                <v-skeleton-loader :loading="module_loading" type="heading"> 
                                                <v-row>                                    
                                                    <v-col cols="12">      
                                                        <div v-for="(item, index) in getModule" :key="index">                                                         
                                                            <v-expansion-panels v-if="index >= moduleLength" class="my-4">
                                                                <v-expansion-panel>
                                                                        <v-expansion-panel-title class="panel-header-role">
                                                                            <div class="d-flex justify-space-between align-center w-100">
                                                                                <span>{{ item.companies_modules.module.name }}</span>
                                                                                <div class="d-flex align-center">
                                                                                    <v-checkbox
                                                                                        :id="'module_all_'+item.companies_modules.module.id+'_right'"
                                                                                        density="compact"
                                                                                        hide-details
                                                                                        color="primary"
                                                                                        :model-value="isModuleAllSelected(item)"
                                                                                        @update:model-value="toggleModuleAllPermissions(item, index, $event)"
                                                                                        @click.stop
                                                                                        class="mr-2"
                                                                                    >
                                                                                        <template v-slot:label>
                                                                                            <span class="text-caption">{{ isModuleAllSelected(item) ? 'Unselect All Module' : 'Select All Module' }}</span>
                                                                                        </template>
                                                                                    </v-checkbox>
                                                                                </div>
                                                                            </div>
                                                                        </v-expansion-panel-title>
                                                                        <v-expansion-panel-text>
                                                                            <v-table class="permission-table"  density="compact" v-for="(sub_module, index2) in item.companies_modules.module.sub_module" :key="index2">
                                                                                    <thead>
                                                                                    <tr>
                                                                                        <th class="text-left" style="width:50%">
                                                                                            <div class="d-flex flex-column">
                                                                                                <strong>{{ sub_module.name }}</strong>
                                                                                                <div class="d-flex align-center mt-1">
                                                                                                    <v-checkbox
                                                                                                        :id="'sub_module_all_'+sub_module.id+'_right'"
                                                                                                        density="compact"
                                                                                                        hide-details
                                                                                                        color="primary"
                                                                                                        :model-value="isSubModuleMenuAllSelected(sub_module)"
                                                                                                        @update:model-value="toggleSubModuleMenuAllPermissions(sub_module, $event)"
                                                                                                        class="pa-0"
                                                                                                    >
                                                                                                        <template v-slot:label>
                                                                                                            <span class="text-caption">{{ isSubModuleMenuAllSelected(sub_module) ? 'Unselect All' : 'Select All' }}</span>
                                                                                                        </template>
                                                                                                    </v-checkbox>
                                                                                                </div>
                                                                                            </div>
                                                                                        </th>
                                                                                        <th class="text-center" style="width:12.5%">
                                                                                            <div class="d-flex flex-column align-center">
                                                                                                <span>View</span>
                                                                                                <v-checkbox
                                                                                                    :id="'sub_view_all_'+item.companies_modules.module.id+'_'+sub_module.id+'_right'"
                                                                                                    density="compact"
                                                                                                    hide-details
                                                                                                    color="indigo"
                                                                                                    :model-value="isSubModuleAllSelected(sub_module, 'view')"
                                                                                                    @update:model-value="selectAllSubModulePermissions(sub_module, 'view', $event)"
                                                                                                ></v-checkbox>
                                                                                            </div>
                                                                                        </th>
                                                                                        <th class="text-center" style="width:12.5%">
                                                                                            <div class="d-flex flex-column align-center">
                                                                                                <span>Insert</span>
                                                                                                <v-checkbox
                                                                                                    :id="'sub_insert_all_'+item.companies_modules.module.id+'_'+sub_module.id+'_right'"
                                                                                                    density="compact"
                                                                                                    hide-details
                                                                                                    color="primary"
                                                                                                    :model-value="isSubModuleAllSelected(sub_module, 'insert')"
                                                                                                    @update:model-value="selectAllSubModulePermissions(sub_module, 'insert', $event)"
                                                                                                ></v-checkbox>
                                                                                            </div>
                                                                                        </th>
                                                                                        <th class="text-center" style="width:12.5%">
                                                                                            <div class="d-flex flex-column align-center">
                                                                                                <span>Update</span>
                                                                                                <v-checkbox
                                                                                                    :id="'sub_update_all_'+item.companies_modules.module.id+'_'+sub_module.id+'_right'"
                                                                                                    density="compact"
                                                                                                    hide-details
                                                                                                    color="info"
                                                                                                    :model-value="isSubModuleAllSelected(sub_module, 'update')"
                                                                                                    @update:model-value="selectAllSubModulePermissions(sub_module, 'update', $event)"
                                                                                                ></v-checkbox>
                                                                                            </div>
                                                                                        </th>
                                                                                        <th class="text-center" style="width:12.5%">
                                                                                            <div class="d-flex flex-column align-center">
                                                                                                <span>Delete</span>
                                                                                                <v-checkbox
                                                                                                    :id="'sub_delete_all_'+item.companies_modules.module.id+'_'+sub_module.id+'_right'"
                                                                                                    density="compact"
                                                                                                    hide-details
                                                                                                    color="red"
                                                                                                    :model-value="isSubModuleAllSelected(sub_module, 'delete')"
                                                                                                    @update:model-value="selectAllSubModulePermissions(sub_module, 'delete', $event)"
                                                                                                ></v-checkbox>
                                                                                            </div>
                                                                                        </th>
                                                                                    </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr v-for="(menu, index3) in sub_module.menu" :key="menu.id" v-if="sub_module.menu.length > 0" hover="true"  :class="{ 'striped-row': index3 % 2 == 1 }">
                                                                                            <td class="text-left pl-25" > <v-icon icon="mdi mdi-square-small" size="x-large"></v-icon>{{ menu.name }}</td>
                                                                                            <td class="py-0 text-center">
                                                                                                <span class="d-flex justify-center">
                                                                                                    <v-checkbox   
                                                                                                        :id="'menu_view_'+menu.id"                         
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="indigo"                                                                                      
                                                                                                        v-model="menuViewPermissions[menu.id]"                                                                                   
                                                                                                    ></v-checkbox>
                                                                                                </span>

                                                                                            </td>
                                                                                            <td class="py-0 text-center">
                                                                                                <span v-if="menu.insert > 0" class="d-flex justify-center">
                                                                                                    <v-checkbox   
                                                                                                        :id="'menu_insert_'+menu.id"                         
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="primary"                                                                                      
                                                                                                        v-model="menuInsertPermissions[menu.id]"                                                                                   
                                                                                                    ></v-checkbox>
                                                                                                </span>

                                                                                            </td>
                                                                                            <td class="py-0 text-center">
                                                                                                <span v-if="menu.update > 0" class="d-flex justify-center">
                                                                                                    <v-checkbox     
                                                                                                        :id="'menu_update_'+menu.id"                       
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="info"   
                                                                                                        v-model="menuUpdatePermissions[menu.id]"                                                        
                                                                                                    ></v-checkbox>
                                                                                                </span>
                                                                                            </td>
                                                                                            <td class="py-0 text-center">
                                                                                                <span v-if="menu.delete > 0" class="d-flex justify-center">
                                                                                                    <v-checkbox      
                                                                                                        :id="'menu_delete_'+menu.id"                      
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="red" 
                                                                                                        v-model="menuDeletePermissions[menu.id]"                                                                           
                                                                                                    ></v-checkbox>
                                                                                                </span>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr v-else>
                                                                                            <td colspan="4" class="text-center"><small class="red" >Menu Not Found</small></td>
                                                                                        </tr>
                                                                                    
                                                                                    </tbody>
                                                                            </v-table>

                                                                        </v-expansion-panel-text>
                                                                    </v-expansion-panel>
                                                            </v-expansion-panels>       
                                                        </div>                                                    
                                                    </v-col>
                                                </v-row>
                                                </v-skeleton-loader>
                                            </v-col>
                                    
                                            
                                            <v-col cols="12"  v-if="!module_loading">
                                                <div class="text-center">
                                                    <v-btn                              
                                                        class="bg-brand w-25"
                                                        type="submit"     
                                                        v-if="getModule.length > 0"                                    
                                                        >Save</v-btn>  
                                                </div>
                                            </v-col>

                                            <v-col cols="10" v-if="!module_loading" class="mx-auto mb-4">
                                                <v-alert v-if="getModule.length == 0" closable text="Data Not Found!" density="compact" type="warning"></v-alert>                                      
                                            </v-col>
                                        </v-row>                                              
                                    <!-- Close Role Permission -->
                       
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>

                    <!-- Data table -->
                </v-form>
            </template>
            <template v-else>
                <v-row>
                    <v-col cols="12">
                        <v-alert
                            color="warning"
                            theme="dark"
                            icon="mdi mdi-alert"
                            border
                            >
                            Permission Not Found
                        </v-alert>
                    </v-col>
                </v-row>
            </template>


        </v-container>
    </v-app>
</template>

<script>

import breadCrumbs from '@/components/utils/breadCrumbs.vue';
import roleSetup from '@/components/module/administration/roleManagement/roleSetup.vue';
import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref, watch } from 'vue';
import { toast } from 'vue3-toastify';
import { useRouter } from 'vue-router'; 

export default {
        components: {
            breadCrumbs,
            roleSetup
        },
        data: () => ({
            panel: [0],
            panel2: [0],
            module_loading: false,
            form_loading: true,
            moduleLength: 0,
            section_show: false,
            errorMessages:'',
            search: "",
            menuViewPermissions: {},
            menuInsertPermissions: {},
            menuUpdatePermissions: {},
            menuDeletePermissions: {},
            dialog: false,
            data:{},
        }),
        watch: {
        },
        created(){
            if(this.$store.getters.getCompanyList.length == 0){this.$store.dispatch('getCompanyList')};
            if(this.$store.getters.getBranchList.length == 0){this.$store.dispatch('getBranchList')};
            if(this.$store.getters.getRoleList.length == 0){this.$store.dispatch('getRoleList') };
        },
        computed:{
            getSchema() {
                return this.$store.getters.getRoleList;
            },
            getModule() {
                let data = this.$store.getters.getModulesByBranch;
                this.moduleLength = Math.ceil(data.length / 2);
                return data;
            },
            getCompanyList() {
                return this.$store.getters.getCompanyList;
            },
            getBranchList(){
                let data = this.$store.getters.getBranchList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            }
        },
        methods: {
            addRoleUrl() {
                this.data = {
                    id: '',
                    name: '',
                    code: '',
                    remarks: '',
                    status: 1,
                };
                this.dialog = true;
            },
            getDataFromApi(){
                this.loading = true;
                this.$store.dispatch('getRoleList')
                .then(data => {
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    toast.error(error.response.data.message); 
                })
                .then(always => {
                    this.loading = false;
                })
            },
            getModulesByBranch(){
                const branch_id =  this.branch_id.value.value;
                if(branch_id != null){
                    this.role_id.value.value = null;
                    this.section_show = true;
                    this.module_loading = true;
                    this.$store.dispatch('getModulesByBranch',branch_id).then(() => {
                        this.module_loading = false;
                        console.log('test');
                    })
                }
                else {
                    this.menuViewPermissions = {};
                    this.menuInsertPermissions = {};
                    this.menuUpdatePermissions = {};
                    this.menuDeletePermissions = {};  
                    this.role_id.value.value = null;                  
                    this.$store.commit('UNSET_GET_ROLES_BY_BRANCH');
                    this.$store.commit('UNSET_MODULE_LIST');
                }
            
            },
            getRolePermission() {
                var self = this;
                if(this.role_id.value.value != null){
                    this.$store.dispatch("getRolePermission", {role_id:this.role_id.value.value})
                    .then((response) => {
                        var data = response.data.data;   
                        this.menuViewPermissions = {};
                        this.menuInsertPermissions = {};
                        this.menuUpdatePermissions = {};
                        this.menuDeletePermissions = {};    
                        data.forEach(function (element, index) {
                                if(element.view == 1){
                                    self.menuViewPermissions[element.menu_id] = true;
                                }
                                if(element.insert == 1){
                                    self.menuInsertPermissions[element.menu_id] = true;
                                }
                                if(element.update == 1){
                                    self.menuUpdatePermissions[element.menu_id] = true;
                                }
                                if(element.delete == 1){
                                    self.menuDeletePermissions[element.menu_id] = true;
                                }
                            });

                    })
                    .catch((error) => {            
         
                    })
                }
                else{
                    this.menuViewPermissions = {};
                    this.menuInsertPermissions = {};
                    this.menuUpdatePermissions = {};
                    this.menuDeletePermissions = {}; 
                }              
            },
            // Check if all permissions of a specific type are selected for a sub-module
            isSubModuleAllSelected(sub_module, permissionType) {
                if (!sub_module.menu || sub_module.menu.length === 0) {
                    return false;
                }
                
                let permissionObject;
                switch(permissionType) {
                    case 'view':
                        permissionObject = this.menuViewPermissions;
                        break;
                    case 'insert':
                        permissionObject = this.menuInsertPermissions;
                        break;
                    case 'update':
                        permissionObject = this.menuUpdatePermissions;
                        break;
                    case 'delete':
                        permissionObject = this.menuDeletePermissions;
                        break;
                    default:
                        return false;
                }
                
                // Check if all menus in this sub-module have the permission selected
                const menusWithPermission = sub_module.menu.filter(menu => {
                    if (permissionType === 'insert' && menu.insert === 0) return false;
                    if (permissionType === 'update' && menu.update === 0) return false;
                    if (permissionType === 'delete' && menu.delete === 0) return false;
                    return true;
                });
                
                if (menusWithPermission.length === 0) return false;
                
                return menusWithPermission.every(menu => permissionObject[menu.id] === true);
            },
            // Select/Deselect all permissions of a specific type for a sub-module
            selectAllSubModulePermissions(sub_module, permissionType, value) {
                if (!sub_module.menu || sub_module.menu.length === 0) {
                    return;
                }
                
                let permissionObject;
                switch(permissionType) {
                    case 'view':
                        permissionObject = this.menuViewPermissions;
                        break;
                    case 'insert':
                        permissionObject = this.menuInsertPermissions;
                        break;
                    case 'update':
                        permissionObject = this.menuUpdatePermissions;
                        break;
                    case 'delete':
                        permissionObject = this.menuDeletePermissions;
                        break;
                    default:
                        return;
                }
                
                // Update all menus in this sub-module
                sub_module.menu.forEach(menu => {
                    // Check if menu supports this permission type
                    if (permissionType === 'insert' && menu.insert === 0) return;
                    if (permissionType === 'update' && menu.update === 0) return;
                    if (permissionType === 'delete' && menu.delete === 0) return;
                    
                    // Direct assignment for reactivity (Vue 3)
                    permissionObject[menu.id] = value;
                });
            },
            // Check if all permissions in a module are selected
            isModuleAllSelected(moduleItem) {
                const module = moduleItem.companies_modules.module;
                if (!module.sub_module || module.sub_module.length === 0) {
                    return false;
                }
                
                // Check all sub-modules
                for (let sub_module of module.sub_module) {
                    if (!sub_module.menu || sub_module.menu.length === 0) {
                        continue;
                    }
                    
                    // Check all menus in this sub-module
                    for (let menu of sub_module.menu) {
                        // Check View permission (always available)
                        if (!this.menuViewPermissions[menu.id]) {
                            return false;
                        }
                        
                        // Check Insert permission (if available)
                        if (menu.insert > 0 && !this.menuInsertPermissions[menu.id]) {
                            return false;
                        }
                        
                        // Check Update permission (if available)
                        if (menu.update > 0 && !this.menuUpdatePermissions[menu.id]) {
                            return false;
                        }
                        
                        // Check Delete permission (if available)
                        if (menu.delete > 0 && !this.menuDeletePermissions[menu.id]) {
                            return false;
                        }
                    }
                }
                
                return true;
            },
            // Toggle all permissions for a module (select all if not all selected, unselect all if all selected)
            toggleModuleAllPermissions(moduleItem, moduleIndex, value) {
                if (value) {
                    this.selectAllModulePermissions(moduleItem, moduleIndex);
                } else {
                    this.unselectAllModulePermissions(moduleItem, moduleIndex);
                }
            },
            // Select all permissions for all menus in a module
            selectAllModulePermissions(moduleItem, moduleIndex) {
                const module = moduleItem.companies_modules.module;
                if (!module.sub_module || module.sub_module.length === 0) {
                    return;
                }
                
                // Iterate through all sub-modules
                module.sub_module.forEach(sub_module => {
                    if (!sub_module.menu || sub_module.menu.length === 0) {
                        return;
                    }
                    
                    // Select all permission types for all menus in this sub-module
                    sub_module.menu.forEach(menu => {
                        // View permission (always available)
                        this.menuViewPermissions[menu.id] = true;
                        
                        // Insert permission (if available)
                        if (menu.insert > 0) {
                            this.menuInsertPermissions[menu.id] = true;
                        }
                        
                        // Update permission (if available)
                        if (menu.update > 0) {
                            this.menuUpdatePermissions[menu.id] = true;
                        }
                        
                        // Delete permission (if available)
                        if (menu.delete > 0) {
                            this.menuDeletePermissions[menu.id] = true;
                        }
                    });
                });
            },
            // Unselect all permissions for all menus in a module
            unselectAllModulePermissions(moduleItem, moduleIndex) {
                const module = moduleItem.companies_modules.module;
                if (!module.sub_module || module.sub_module.length === 0) {
                    return;
                }
                
                // Iterate through all sub-modules
                module.sub_module.forEach(sub_module => {
                    if (!sub_module.menu || sub_module.menu.length === 0) {
                        return;
                    }
                    
                    // Unselect all permission types for all menus in this sub-module
                    sub_module.menu.forEach(menu => {
                        // View permission (always available)
                        this.menuViewPermissions[menu.id] = false;
                        
                        // Insert permission (if available)
                        if (menu.insert > 0) {
                            this.menuInsertPermissions[menu.id] = false;
                        }
                        
                        // Update permission (if available)
                        if (menu.update > 0) {
                            this.menuUpdatePermissions[menu.id] = false;
                        }
                        
                        // Delete permission (if available)
                        if (menu.delete > 0) {
                            this.menuDeletePermissions[menu.id] = false;
                        }
                    });
                });
            },
            // Select all permissions for all menus in a sub-module (menu-wise)
            selectAllSubModuleMenuPermissions(sub_module) {
                if (!sub_module.menu || sub_module.menu.length === 0) {
                    return;
                }
                
                // Select all permission types for all menus in this sub-module
                sub_module.menu.forEach(menu => {
                    // View permission (always available)
                    this.menuViewPermissions[menu.id] = true;
                    
                    // Insert permission (if available)
                    if (menu.insert > 0) {
                        this.menuInsertPermissions[menu.id] = true;
                    }
                    
                    // Update permission (if available)
                    if (menu.update > 0) {
                        this.menuUpdatePermissions[menu.id] = true;
                    }
                    
                    // Delete permission (if available)
                    if (menu.delete > 0) {
                        this.menuDeletePermissions[menu.id] = true;
                    }
                });
            },
            // Unselect all permissions for all menus in a sub-module (menu-wise)
            unselectAllSubModuleMenuPermissions(sub_module) {
                if (!sub_module.menu || sub_module.menu.length === 0) {
                    return;
                }
                
                // Unselect all permission types for all menus in this sub-module
                sub_module.menu.forEach(menu => {
                    // View permission (always available)
                    this.menuViewPermissions[menu.id] = false;
                    
                    // Insert permission (if available)
                    if (menu.insert > 0) {
                        this.menuInsertPermissions[menu.id] = false;
                    }
                    
                    // Update permission (if available)
                    if (menu.update > 0) {
                        this.menuUpdatePermissions[menu.id] = false;
                    }
                    
                    // Delete permission (if available)
                    if (menu.delete > 0) {
                        this.menuDeletePermissions[menu.id] = false;
                    }
                });
            },
            // Check if all permissions for all menus in a sub-module are selected (menu-wise)
            isSubModuleMenuAllSelected(sub_module) {
                if (!sub_module.menu || sub_module.menu.length === 0) {
                    return false;
                }
                
                // Check all menus in this sub-module
                for (let menu of sub_module.menu) {
                    // Check View permission (always available)
                    if (!this.menuViewPermissions[menu.id]) {
                        return false;
                    }
                    
                    // Check Insert permission (if available)
                    if (menu.insert > 0 && !this.menuInsertPermissions[menu.id]) {
                        return false;
                    }
                    
                    // Check Update permission (if available)
                    if (menu.update > 0 && !this.menuUpdatePermissions[menu.id]) {
                        return false;
                    }
                    
                    // Check Delete permission (if available)
                    if (menu.delete > 0 && !this.menuDeletePermissions[menu.id]) {
                        return false;
                    }
                }
                
                return true;
            },
            // Toggle all permissions for all menus in a sub-module (menu-wise)
            toggleSubModuleMenuAllPermissions(sub_module, value) {
                if (value) {
                    this.selectAllSubModuleMenuPermissions(sub_module);
                } else {
                    this.unselectAllSubModuleMenuPermissions(sub_module);
                }              
            }
        },
        setup() {
            
            const { handleSubmit} = useForm({
                validationSchema: yup.object({
                    role_id: yup.number().positive().integer().required().label('Role Name'),
                    branch_id: yup.number().positive().integer().required().label('Branch Name'),       
                }),
            });

            const role_id = useField('role_id');
            const company_id = useField('company_id');
            const branch_id = useField('branch_id');
            const errorMessages  = ref('');
            const loading  = ref('');
            const menuViewPermissions  =  ref({});
            const menuInsertPermissions  =  ref({});
            const menuUpdatePermissions  =  ref({});
            const menuDeletePermissions  =  ref({});
            const store = useStore();
            const router = useRouter();

            watch(() => company_id.value.value, () => {
                branch_id.value.value = null;
            });

            const submit = handleSubmit((values) => { 
                 // Data rearrange
                    var data = {};
                    data.view = menuViewPermissions.value;            
                    data.insert = menuInsertPermissions.value;            
                    data.update = menuUpdatePermissions.value;            
                    data.delete = menuDeletePermissions.value; 
                    const mergedData = Object.keys(data).reduce((result, key) => {
                        const subData = data[key];
                        Object.keys(subData).forEach(subKey => {
                            if (subData[subKey] == true) { 
                                if (!result[subKey]) {
                                    result[subKey] = [];
                                }
                                result[subKey].push(key);
                            }
                        });
                        return result;
                    }, {});

                    values.data = mergedData; 
                //close data rearrange
                
                store.dispatch("saveRolePermission", values)
                    .then((response) => {                       
                        var menu_ind = response.data;
                        if(menu_ind.hasOwnProperty('menu')){
                            toast.success('Your Permission Updated');
                            router.push('/home/dashboard');
                        }
                        else{
                            toast.success(response.data.message);
                        } 
                    })
                    .catch((error) => { 
                        toast.error(error.response.data.message);              
                    })


            })
            return {
            submit,
            errorMessages,
            role_id,
            company_id,
            branch_id,
            menuViewPermissions,
            menuInsertPermissions,
            menuUpdatePermissions,
            menuDeletePermissions,
            loading
            }
        },
        mounted() {
            // this.getDataFromApi();
            this.$store.commit('UNSET_MODULE_LIST')         
          }  
    }
</script>

<style >
    .permission-table tbody tr td{
        font-size: 16px !important;
    }
    .pl-25{
        padding-left:25px !important;
    }
    .striped-row {
        background-color: #d7d7d738;
    }
</style>

                    .then((response) => {                       

                        var menu_ind = response.data;

                        if(menu_ind.hasOwnProperty('menu')){

                            toast.success('Your Permission Updated');

                            router.push('/home/dashboard');

                        }

                        else{

                            toast.success(response.data.message);

                        } 

                    })

                    .catch((error) => { 

                        toast.error(error.response.data.message);              

                    })





            })

            return {

            submit,

            errorMessages,

            role_id,

            company_id,

            branch_id,

            menuViewPermissions,

            menuInsertPermissions,

            menuUpdatePermissions,

            menuDeletePermissions,

            loading

            }

        },

        mounted() {

            // this.getDataFromApi();

            this.$store.commit('UNSET_MODULE_LIST')         

          }  

    }



<style >

    .permission-table tbody tr td{

        font-size: 16px !important;

    }

    .pl-25{

        padding-left:25px !important;

    }

    .striped-row {

        background-color: #d7d7d738;

    }

</style>
